import React, { useEffect, useState } from 'react';
import VideoTaskContent from '../VideoTaskContent';
import { Dialog, useMediaQuery } from '@mui/material';
import { routeMappings } from '../../../constants';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { VideoTaskConfiguration } from '../../interfaces/videoTask';
import { useAppSelector } from '../../../store/hook';
import { DialogStyles } from '../../../common/styles/dialog';

interface VideoTaskLayoutProps {
  getNextWorkflowItem?(): Promise<void>;
  closePopup?(): void;
  isVideoFromJourney?: boolean;
  videoTaskConfiguration: VideoTaskConfiguration;
}

const VideoTaskLayout = (props: VideoTaskLayoutProps): React.JSX.Element => {
  const navigate = useNavigate();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const workflowItem = useAppSelector((state) => state.currentWorkflowItem);
  const { getNextWorkflowItem, videoTaskConfiguration, closePopup, isVideoFromJourney = false } = props;
  const root = document.getElementById('root');

  const [open, setOpen] = useState(false);
  useEffect(() => {
    setOpen(true);
    root?.setAttribute('inert', '');
    return (): void => {
      setOpen(false);
      root?.removeAttribute('inert');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { classes } = DialogStyles({ backgroundColor: videoTaskConfiguration.popupBackgroundColor });

  const goBack = (): void => {
    if (closePopup) {
      closePopup();
      setOpen(false);
    } else navigate(`${routeMappings['TASKLIST']}/${workflowItem.id}`);
    root?.removeAttribute('inert');
  };

  return (
    <Dialog
      className={classes.dialogContainer}
      fullScreen={fullScreen}
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          goBack();
        }
      }}
      aria-labelledby="dialog-title"
      disableEnforceFocus
      disableEscapeKeyDown>
      <VideoTaskContent
        getNextWorkflowItem={getNextWorkflowItem}
        videoTaskConfiguration={videoTaskConfiguration}
        open={open}
        goBack={goBack}
        isVideoFromJourney={isVideoFromJourney}
      />
    </Dialog>
  );
};

export default VideoTaskLayout;
